<template>
    <baidu-map class="bm-view" center="南昌" :scroll-wheel-zoom="true" :zoom="zoom" ak="E1ApfPwSdD6sz1UGw6wotWO4QBdORjYn" @ready="handler" :mapStyle="mapStyle">
        <!-- 比例尺 -->
        <bm-scale anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-scale>
        <!-- 缩放 -->
        <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
        <!-- 地图类型 ['BMAP_NORMAL_MAP', 'BMAP_SATELLITE_MAP'] -->
        <bm-map-type :map-types="['BMAP_SATELLITE_MAP']" anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-map-type>
        <!-- 定位 -->
        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
        <!-- 点 -->
        <bml-marker-clusterer :averageCenter="true">
            <bm-marker :position="{lng: 115.904539, lat: 28.686507}"  @click="clickMarker(1)">
                <bm-label
                  :content="1"
                  :labelStyle="{fontSize : '14px'}"
                />
                <!-- <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">我爱北京天安门</bm-info-window> -->
            </bm-marker>
            <bm-marker :position="{lng: 115.887, lat: 28.6661}"  @click="clickMarker(2)">
                <bm-label
                  :content="2"
                  :labelStyle="{fontSize : '14px'}"
                />
            </bm-marker>
        </bml-marker-clusterer>
        <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen" :position="positiaon">站点</bm-info-window>
    </baidu-map>
</template>

<script>
import {
    BmLocalSearch,
    BmMarker,
    BmGeolocation,
    BmScale,
    BmNavigation,
    BmMapType,
    BmInfoWindow,
    BmPointCollection,
    BmLabel,
    BmlMarkerClusterer
} from "vue-baidu-map";
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import {mapStyle,mapStyle2} from '@/util/map.js'
export default {
    name: "BaiduMapView",
    components: {
        BaiduMap,
        BmGeolocation,
        BmMarker,
        BmScale,
        BmNavigation,
        BmMapType,
        BmInfoWindow,
        BmPointCollection,
        BmLabel,
        BmlMarkerClusterer
    },
    data(){
        return {
            zoom: 5,
            mapStyle: mapStyle2,  //自定义地图样式
            show: false,
            // points: [
            //     {lng: 115.904539, lat: 28.686507},
            //     {lng: 115.887, lat: 28.6661}
            // ],
            positiaon: null,
        }
    },
    methods: {
        handler({BMap,map}) {
            // console.log(this.mapStyle)
            //使用3.0js版本set值
            // console.log(map)
            // map.setMapStyleV2({
            //      styleId: '5c5cd2313e6e6fc3f2a880c668165945',
            // })
        },
        infoWindowClose () {
            this.show = false
        },
        infoWindowOpen () {
            this.show = true
        },
        clickMarker(item) {
            this.show = true
            if(item == 1) {
                this.positiaon = {lng: 115.904539, lat: 28.686507}
            }else {
                this.positiaon = {lng: 115.887, lat: 28.6661}
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.bm-view {
  width: 100%;
  height: 100%;
  // border-radius: 10%;
}
</style>